'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

exports.default = {
  media: _react.PropTypes.object,
  _mediaSetters: _react.PropTypes.object,
  _mediaGetters: _react.PropTypes.object
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-media-player/lib/context-types.js
 ** module id = 152
 ** module chunks = 0
 **/